import IContact from 'interfaces/contacts/IContact';

export default (customers: IContact[]): { value: any; label: string }[] =>
  customers.map((x: any) => ({
    value: x.id,
    label: `${x.companyName} (${x.businessId})`,
  }));
